import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import * as UserActions from '../../../actions/user_actions';
import * as PatientsActions from '../../../actions/admin/patients_actions';
import * as FacilitiesActions from '../../../actions/facilities_actions';
import { bindActionCreators } from 'redux';
import { ModalDialogCommon } from '../../modal_dialog_common';
import { validate } from '../../../validations';
import Header from '../../../components/header';
let screenIdentifier = 'patientsList';
import _ from 'lodash';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import Pagination from "react-js-pagination";
import { CopyToClipboard } from 'react-copy-to-clipboard';

export var PatientsList = React.createClass({
  getInitialState() {
    return {
      data_rq: false,
      allPatientsData: null,
      getPatientData: false, CurrentTab: 0, showFilter: false, loader: true, isDrThrRequested: false, PsychiatristList: null, TheraoistList: null, isDrPsyRequested: false,
      showPsychList: false,
      showTherpList: false,
      isUploadCsvSubmitted: null,
      okModalMessage: null,
      selectedPsyc: 0,
      selectedTherp: 0,
      redflagData: false,
      //pagination
      pageNO: 1, // To make currentPage active in UI
      PageSize: 20,
      totalRecords: 2,
      searchWord: '',
      userStatusType: 'REDFLAG',
      isFilterApplied: null,
      resendLinkClicked: false,
      showCsvModal: false,
      isShowDeleteModal: false,
      deletePatientId: '',
      copiedToClipboard: false,
      isRedFlaggedClicked: true,
      searchCharacter: null
    }
  },
  componentWillMount() {

    let facilitiesID = this.props.UserDetails.selectdUserFacilityID;
    //this.props.Dispatch(PatientsActions.getAllPaientsData(facilitiesID));
    this.props.Dispatch(UserActions.getUsersByRole(
      {
        "id": this.props.UserDetails.selectdUserFacilityID,
        "roleId": 7,
        "searchChar": "",
        "status": "REDFLAG",
        "page": 1,
        "size": 20
      }
    ));
  },
  componentWillReceiveProps(nextProps) {
    if (nextProps.UserDetails.UsersByRole && nextProps.UserDetails.UsersByRole.data && nextProps.UserDetails.UsersByRole.status === 200) {
      nextProps.UserDetails.UsersByRole.status = null;
      this.setState({ allPatientsData: nextProps.UserDetails.UsersByRole.data.result, totalRecords: nextProps.UserDetails.UsersByRole.data.totalSize, loader: false });

      this.setState({ redflagData: false });
    }
    else {
      this.setState({ loader: false });
    }
    this.callResendLinkClicked(nextProps)

    this.state.getPatientData && nextProps.FacilitiesDetails.FaciliteAdminUser.status === 200 && this.props.router.push('/patients-details' + (this.state.CurrentTab === 0 ? '?tab=red_flag' : ''));

    let Psychiatrist = nextProps.UserDetails.PsychiatristList;
    let TheraoistList = nextProps.UserDetails.TheraoistList;

    Psychiatrist && Psychiatrist.status == 200 && this.setState({ PsychiatristList: Psychiatrist.data });
    TheraoistList && TheraoistList.status == 200 && this.setState({ TheraoistList: TheraoistList.data });

    if (this.state.isUploadCsvSubmitted && nextProps.UserDetails.FileUploadRegistrationResponse) {
      this.setState({ isUploadCsvSubmitted: null });
      if (nextProps.UserDetails.FileUploadRegistrationResponse.status === 200) {
        this.setState({ okModalMessage: nextProps.UserDetails.FileUploadRegistrationResponse.message })
      }
      else {
        this.setState({
          okModalMessage: nextProps.UserDetails.FileUploadRegistrationResponse.message
        });
      }
    }
    if (nextProps.userDeleted && nextProps.userDeleted.status === 200) {
      this.handleSelect(3);
      this.props.Dispatch(UserActions.user_delete(null));
    }
  },

  componentDidMount() {

    let data = this.props.UserDetails.selectdUserFacilityID;
    this.props.Dispatch(UserActions.getTherapistList(data));
    this.props.Dispatch(UserActions.getPsychiatristList(data));
    this.setState({ isDrThrRequested: true, isDrPsyRequested: true })


  },

  callResendLinkClicked(nextProps) {
    if (this.state.resendLinkClicked) {
      if (nextProps.FacilitiesDetails.ResendLinkStatus) {
        this.props.Dispatch(UserActions.getUsersByRole(
          {
            "id": this.props.UserDetails.selectdUserFacilityID,
            "roleId": 7,
            "searchChar": "",
            "status": "EXPIRED",
            "page": 1,
            "size": 20
          }
        ));
        this.setState({ oKModalMessage: nextProps.FacilitiesDetails.ResendLinkStatus.message });
        nextProps.FacilitiesDetails.ResendLinkStatus = null;
      }
      this.setState({ resendLinkClicked: false })
      let faciliti_id = this.props.UserDetails.selectdUserFacilityID;
      this.props.Dispatch(FacilitiesActions.getAllfacilitiesById(faciliti_id));
    }
  },

  handleSelect(index, last) {
    //console.log('Selected tab: ' + index + ', Last tab: ' + last);
    if (index !== 0) {
      this.setState({ isRedFlaggedClicked: false })
    } else {
      this.setState({ isRedFlaggedClicked: true })
    }
    this.setState({ CurrentTab: index });
    // if (index == 0) {
    //   return;
    // }

    if (this.state.isFilterApplied) {
      this.setState({ 'isFilterApplied': null });
    }

    let userStatusType = 'NA';
    switch (index) {
      case 0: {
        userStatusType = 'REDFLAG';

      }
        break;
      case 1: {
        userStatusType = 'APPROVE'
      }
        break;
      case 2: {
        userStatusType = 'DEACTIVATED'
      }
        break;
      case 3: {
        userStatusType = 'ACCEPTED'
      }
        break;
      case 4: {
        userStatusType = 'EXPIRED'
      }
        break;
      case 5: {
        userStatusType = 'NA'
      }
        break;
      default:
        break;
    }

    this.setState({ pageNO: 1 }); // To make the pageNo active in UI component.
    this.setState({ userStatusType: userStatusType });
    this.props.Dispatch(UserActions.getUsersByRole(
      {
        "id": this.props.UserDetails.selectdUserFacilityID,
        "roleId": 7,
        "searchChar": this.state.searchWord,
        "status": userStatusType,
        "page": 1,
        "size": this.state.PageSize,
      }
    ));
  },
  closebox() {
    this.setState({ okModalMessage: null });
    this.refs.fileUrl.value = null;
  },

  remove_error(event) {
    event.target.className = 'inputText';
    this.setState({ isEmailTrue: false, isurleTrue: false, isZipTrue: false });
  },
  add_patient() {
    this.props.router.push('/add-patients#new')
  },
  getUserById(event) {
    let target = event.target || event.srcElement || event.currentTarget;
    // console.log(target.tagName);
    if (target.tagName === 'TD' || target.tagName === 'SPAN') {
      var patientsID = event.currentTarget.dataset.pa_id;
      this.setState({ getPatientData: true });
      this.props.Dispatch(FacilitiesActions.getAdminUserById(patientsID + "/" + this.props.UserDetails.selectdUserFacilityID));
    } else if (target.tagName === 'IMG') {
      var patientsID = event.currentTarget.dataset.pa_id;
      this.setState({ isShowDeleteModal: true, deletePatientId: patientsID });
    }
    // else if (target.tagName === 'P') {
    //   console.log('p');
    // }
  },

  deletePatientById() {
    this.props.Dispatch(UserActions.deleteUser(this.state.deletePatientId));
    this.setState({ isShowDeleteModal: false });
  },

  // need to remove
  searchPatient(event) {

    let value_name = event.target.value.toLowerCase();

    var currentlist = this.props.PatientsDetails.AllPatientsData.data;

    var results = _.filter(currentlist, function (item) {

      return item.firstName.toLowerCase().indexOf(value_name) > -1 || item.lastName.toLowerCase().indexOf(value_name) > -1 || item.email.toLowerCase().indexOf(value_name) > -1 || item.mobile.toLowerCase().indexOf(value_name) > -1;
    });

    if (value_name.length == 0) {
      this.setState({ allPatientsData: this.props.PatientsDetails.AllPatientsData.data });
    }

    else { this.setState({ allPatientsData: results }); }

    //  return fillterdList;
  },
  // showFilter() { // show hide filter
  //   let filterFlag = this.state.showFilter ? false : true;
  //   this.setState({ showFilter: filterFlag });
  // },
  getdoctorlist() {

    //let PsychiatristList = this.props.UserDetails.Psychiatrist && this.props.UserDetails.Psychiatrist.data ;

    let PsychiatristList = this.state.PsychiatristList;
    let TheraoistListList = this.state.TheraoistList;
    if (!PsychiatristList && !TheraoistListList) {
      return false;
    }

    let newPsychiatristList = PsychiatristList && PsychiatristList.map(function (list, key1) {

      return (<li key={key1}><input value={list.id} name={"psyc"} type="radio" id={key1 + "_psyc"} /> <label htmlFor={key1 + "_psyc"}>{list.firstName + " " + list.lastName}</label></li>)
    }, this);



    let newTheraoistListList = TheraoistListList && TheraoistListList.map(function (list, key2) {
      return (<li key={key2}><input value={list.id} name={"therp"} type="radio" id={key2 + "_therp"} /> <label htmlFor={key2 + "_therp"}>{list.firstName + " " + list.lastName}</label></li>)
    }, this);

    return { PsychiatristList: newPsychiatristList, TheraoistListList: newTheraoistListList }
  },
  showFilter(event) { // show hide filter
    let filterFlag = this.state.showFilter ? false : true;
    this.setState({ showFilter: filterFlag });

    if (event.offsetX > event.offsetWidth) {
      this.setState({ showFilter: false });
    } else {

    }
  },
  showPsychList() {
    let stateFlag = this.state.showPsychList ? false : true;
    this.setState({ showPsychList: stateFlag, showTherpList: false })
  },
  showTherpList() {
    let stateFlag = this.state.showTherpList ? false : true;
    this.setState({ showPsychList: false, showTherpList: stateFlag })
  },
  closeFilter() {

    this.setState({ showFilter: false, showPsychList: false, showTherpList: false })
  },
  unCheckList() {
    // this.setState({ selectedPsyc: 0, selectedTherp: 0 });

    // var list = document.getElementsByTagName("input");
    // for (var i = 0; i < list.length; i++) {
    //   list[i].checked = false;
    // }
    // this.closeFilter();
    // let f_id = this.props.UserDetails.selectdUserFacilityID;
    // let data = f_id + "/" + this.state.isRedFlaggedClicked + "/" + 0 + "/" + 0 + "/1/" + this.state.PageSize; // pageNo :1; pageSize :20
    // this.props.Dispatch(UserActions.get_fillter_patient(data));
    this.closeFilter();
    this.props.Dispatch(UserActions.getUsersByRole(
      {
        "id": this.props.UserDetails.selectdUserFacilityID,
        "roleId": 7,
        "searchChar": this.state.searchWord,
        "status": this.state.userStatusType,
        "page": 1,
        "size": this.state.PageSize,
      }
    ));

  },
  applyFilter() {
    this.setState({ showFilter: false });
    this.setState({ isFilterApplied: true });
    this.refs.searchWord.value = '';
    this.setState({ searchWord: '' });
    let roleID = this.props.UserDetails.selectedUserRoleID;

    // (roleID === 1 || roleID === 2) ? this.setState({ CurrentTab: 4 }) : this.setState({ CurrentTab: 1 }); // while filter applied, filter api response has all types of status,  Hence to enalbe 4th tab

    // console.log(this.state.CurrentTab);

    let f_id = this.props.UserDetails.selectdUserFacilityID,
      psychiartristId = this.state.selectedPsyc,
      therapistId = this.state.selectedTherp;
    let data = f_id + "/" + this.state.isRedFlaggedClicked + "/" + psychiartristId + "/" + therapistId + "/1/" + this.state.PageSize; // pageNo :1; pageSize :20
    this.props.Dispatch(UserActions.get_fillter_patient(data));

  },
  selectPsyc(event) {
    this.setState({ selectedPsyc: event.target.value });
  },
  selectTherp(event) {
    this.setState({ selectedTherp: event.target.value });
  },
  uploadPatientsCSV(e) {
    var uploadedFile = e.target.files[0];
    var uploadedFilePath = uploadedFile.name;

    //To check if user upload any file
    var Extension = uploadedFilePath.substring(
      uploadedFilePath.lastIndexOf('.') + 1).toLowerCase();
    if (Extension == "xlsx" || Extension == "xls" || Extension == "csv") {
      var fileToUpload = new FormData();
      fileToUpload.append("fileToUpload", e.target.files[0]);
      this.setState({ isUploadCsvSubmitted: true });
      this.props.Dispatch(UserActions.uploadPatientsRegistrationFile(fileToUpload, this.props.UserDetails.selectdUserFacilityID, this.props.UserDetails.loginData.data.id));
    }
    else {
      e.target.value = "";
      this.setState({ okModalMessage: 'Please upload the file with .xlsx, .xls, .csv extension only.' });
    }
  },

  //On Search word change -- To get searched facilities with entered character
  onSearchChange(event) {
    // if (event.target.value.trim().length === 0) {
    //   return;
    // }
    if (event.target.value.length >= 3) {
      if (event.target.value.includes('@')) {
        if (event.target.value.includes('.')) {
          // alert(event.target.value)
          this.setState({ searchCharacter: event.target.value.trim(), searchWord: event.target.value.trim() });
          setTimeout(() => {
            // console.log('after 3s in email')
            this.setState({ pageNO: 1 }); // To make the pageNo active in UI component.
            this.props.Dispatch(UserActions.getUsersByRole(
              {
                "id": this.props.UserDetails.selectdUserFacilityID,
                "roleId": 7,
                "searchChar": this.state.searchCharacter,
                "status": this.state.userStatusType,
                "page": 1,
                "size": this.state.PageSize,
              }
            ));
          }, 3000);
        }
      } else {
        this.setState({ searchCharacter: event.target.value.trim(), searchWord: event.target.value.trim() });
        setTimeout(() => {
          // console.log('after 3s in email')
          this.setState({ pageNO: 1 }); // To make the pageNo active in UI component.
          this.props.Dispatch(UserActions.getUsersByRole(
            {
              "id": this.props.UserDetails.selectdUserFacilityID,
              "roleId": 7,
              "searchChar": this.state.searchCharacter,
              "status": this.state.userStatusType,
              "page": 1,
              "size": this.state.PageSize,
            }
          ));
        }, 3000);
      }
    } else if (event.target.value.length === 0) {
      this.setState({ searchWord: event.target.value.trim() });
      this.setState({ pageNO: 1 }); // To make the pageNo active in UI component.
      this.props.Dispatch(UserActions.getUsersByRole(
        {
          "id": this.props.UserDetails.selectdUserFacilityID,
          "roleId": 7,
          "searchChar": event.target.value.trim(),
          "status": this.state.userStatusType,
          "page": 1,
          "size": this.state.PageSize,
        }
      ));
    }
  },
  resendLink(event) {
    let facilityId = this.props.UserDetails.selectdUserFacilityID;
    let id = event.target.attributes['data-pa_id'].value;
    // this.props.Dispatch(FacilitiesActions.RequestResendLink(id + "/" + facilityId + "/" + this.props.UserDetails.selectedUserRoleID));
    this.props.Dispatch(FacilitiesActions.RequestResendLink(id + "/" + facilityId + "/" + "7"));
    this.setState({ resendLinkClicked: true })
  },
  onDownload() {
    this.setState({ showCsvModal: false })
    window.open('https://ucdavis-prod.s3-us-west-1.amazonaws.com/patient_upload_sample.csv');
  },
  //on Page Change -- To get searched facilities with entered character
  onPageChange(pageNumber) {
    this.setState({ pageNO: pageNumber });

    if (this.state.isFilterBy) {
      let f_id = this.props.UserDetails.selectdUserFacilityID,
        psychiartristId = this.state.selectedPsyc,
        therapistId = this.state.selectedTherp;
      let data = f_id + "/" + psychiartristId + "/" + therapistId + "/" + pageNumber + "/" + this.state.PageSize; // pageNo :1; pageSize :20

      this.props.Dispatch(UserActions.get_fillter_patient(data));
      return;
    }

    this.props.Dispatch(UserActions.getUsersByRole(
      {
        "id": this.props.UserDetails.selectdUserFacilityID,
        "roleId": 7,
        "searchChar": this.state.searchWord,
        "status": this.state.userStatusType,
        "page": pageNumber,
        "size": this.state.PageSize,
      }
    ));
  },
  formatDate(e) {
    if (e === null) {
      return "-";
    } else {
      var date = new Date(e);
      var year = date.getFullYear(), // get only two digits
        month = date.getMonth() + 1, day = date.getDate();
      return month + '/' + day + '/' + year;
    }
  },
  onCopyText() {
    this.setState({ copiedToClipboard: true });
  },
  copied() {
    this.setState({ copiedToClipboard: false })
  },
  render() {
    let class_name = "activate";
    let roleID = this.props.UserDetails.selectedUserRoleID;
    var allPatienData = this.state.allPatientsData && this.state.allPatientsData.length ? this.state.allPatientsData.map(function (list, key) {

      return (<tr key={key} data-pa_id={list.user.id} onClick={this.getUserById} ><td>
        <CopyToClipboard text={list.user.guid} onCopy={this.onCopyText}>
          <p className='guid' title={'copy to clipboard'}>{list.user.guid}</p>
        </CopyToClipboard></td><td><span className="patient-overflow" data-pa_id={list.user.id} >{list.user.firstName + " " + list.user.lastName}</span></td><td><span className="patient-overflow">{list.user.email}</span></td><td>{list.user.mobile}</td><td>{list.user.psychiatrist ? list.user.psychiatrist.firstName + ' ' + list.user.psychiatrist.lastName : 'NA'}</td><td>{list.user.therapist ? list.user.therapist.firstName + ' ' + list.user.therapist.lastName : 'NA'}</td><td>{list.status == "APPROVE" ? 'ACTIVE' : list.status == "ACCEPTED" ? "PENDING" : list.status}</td></tr>)
    }, this) : (<tr><td>No records to display.</td></tr>);


    var redFlagPatienData = this.state.allPatientsData && _.filter(this.state.allPatientsData, function (item) {
      return item.status === 'REDFLAG';
    });
    redFlagPatienData = redFlagPatienData && redFlagPatienData.length ? redFlagPatienData.map(function (list, key) {

      return (<tr key={key} data-pa_id={list.user.id} onClick={this.getUserById}><td><CopyToClipboard text={list.user.guid} onCopy={this.onCopyText}>
        <p className='guid' title={'copy to clipboard'}>{list.user.guid}</p>
      </CopyToClipboard></td><td><span className="patient-overflow" data-pa_id={list.user.id} >{list.user.firstName + " " + list.user.lastName}</span></td><td><span className="patient-overflow">{list.user.email}</span></td><td>{list.user.mobile}</td><td>{list.user.psychiatrist ? list.user.psychiatrist.firstName + ' ' + list.user.psychiatrist.lastName : 'NA'}</td><td>{list.user.therapist ? list.user.therapist.firstName + ' ' + list.user.therapist.lastName : 'NA'}</td><td>{list.status == "APPROVE" ? 'ACTIVE' : list.status}</td></tr>)
    }, this) : (<tr ><td colSpan="4">No records to display.</td></tr>);

    var activePatienData = this.state.allPatientsData && _.filter(this.state.allPatientsData, function (item) {
      return item.status === "APPROVE";
    });
    activePatienData = activePatienData && activePatienData.length ? activePatienData.map(function (list, key) {
      return (<tr key={key} data-pa_id={list.user.id} onClick={this.getUserById}><td><CopyToClipboard text={list.user.guid} onCopy={this.onCopyText}>
        <p className='guid' title={'copy to clipboard'}>{list.user.guid}</p>
      </CopyToClipboard></td><td><span className="patient-overflow" data-pa_id={list.user.id} >{list.user.firstName + " " + list.user.lastName}</span></td><td><span className="patient-overflow">{list.user.email}</span></td><td>{list.user.mobile}</td><td>{list.user.psychiatrist ? list.user.psychiatrist.firstName + ' ' + list.user.psychiatrist.lastName : 'NA'}</td><td>{list.user.therapist ? list.user.therapist.firstName + ' ' + list.user.therapist.lastName : 'NA'}</td><td>{list.status == "APPROVE" ? 'ACTIVE' : list.status}</td></tr>)
    }, this) : (<tr ><td colSpan="4">No records to display.</td></tr>);

    var pendingPatienData = this.state.allPatientsData && _.filter(this.state.allPatientsData, function (item) {
      return item.status === "ACCEPTED";
    });
    pendingPatienData = pendingPatienData && pendingPatienData.length ? pendingPatienData.map(function (list, key) {
      return (<tr key={key} data-pa_id={list.user.id} onClick={this.getUserById}><td><CopyToClipboard text={list.user.guid} onCopy={this.onCopyText}>
        <p className='guid' title={'copy to clipboard'}>{list.user.guid}</p>
      </CopyToClipboard></td><td><span className="patient-overflow" data-pa_id={list.user.id}  >{list.user.firstName + " " + list.user.lastName}</span></td><td><span className="patient-overflow">{list.user.email}</span></td><td>{list.user.mobile}</td><td>{list.user.psychiatrist ? list.user.psychiatrist.firstName + ' ' + list.user.psychiatrist.lastName : 'NA'}</td><td>{list.user.therapist ? list.user.therapist.firstName + ' ' + list.user.therapist.lastName : 'NA'}</td><td>{"PENDING"}</td><td><img src={require('./../../../images/delete.png')} width={24} /></td></tr>)
    }, this) : (<tr><td colSpan="4">No records to display.</td></tr>);

    var expiredPatienData = this.state.allPatientsData && _.filter(this.state.allPatientsData, function (item) {
      return item.status === "EXPIRED";
    });
    expiredPatienData = expiredPatienData && expiredPatienData.length ? expiredPatienData.map(function (list, key) {
      return (<tr key={key} data-pa_id={list.user.id} onClick={this.getUserById}><td><CopyToClipboard text={list.user.guid} onCopy={this.onCopyText}>
        <p className='guid' title={'copy to clipboard'}>{list.user.guid}</p>
      </CopyToClipboard></td><td><span className="patient-overflow" data-pa_id={list.user.id}  >{list.user.firstName + " " + list.user.lastName}</span></td><td><span className="patient-overflow">{list.user.email}</span></td><td>{this.formatDate(list.statusUpdatedDate)}</td><td>{list.user.mobile}</td><td>{list.user.psychiatrist ? list.user.psychiatrist.firstName + ' ' + list.user.psychiatrist.lastName : 'NA'}</td><td>{list.user.therapist ? list.user.therapist.firstName + ' ' + list.user.therapist.lastName : 'NA'}</td><td>{'EXPIRED'}</td><td><button data-pa_id={list.user.id} onClick={this.resendLink} className={class_name}>{"RESEND"}</button></td></tr>)
    }, this) : (<tr><td colSpan="4">No records to display.</td></tr>);

    var deactivePatienData = this.state.allPatientsData && _.filter(this.state.allPatientsData, function (item) {
      return item.status === "DEACTIVATED";
    });
    deactivePatienData = deactivePatienData && deactivePatienData.length ? deactivePatienData.map(function (list, key) {
      return (<tr key={key} data-pa_id={list.user.id} onClick={this.getUserById}><td><CopyToClipboard text={list.user.guid} onCopy={this.onCopyText}>
        <p className='guid' title={'copy to clipboard'}>{list.user.guid}</p>
      </CopyToClipboard></td><td><span className="patient-overflow" data-pa_id={list.user.id}   >{list.user.firstName + " " + list.user.lastName}</span></td><td><span className="patient-overflow">{list.user.email}</span></td><td>{this.formatDate(list.statusUpdatedDate)}</td><td>{list.user.mobile}</td><td>{list.user.psychiatrist ? list.user.psychiatrist.firstName + ' ' + list.user.psychiatrist.lastName : 'NA'}</td><td>{list.user.therapist ? list.user.therapist.firstName + ' ' + list.user.therapist.lastName : 'NA'}</td><td>{list.status}</td></tr>)
    }, this) : (<tr><td colSpan="4">No records to display.</td></tr>);


    let drData = this.getdoctorlist();
    return (
      <div className="dashboard-inner-content">
        <Header loader={this.state.loader} screenIdentifier={screenIdentifier} />

        <div>
          <div className="row">

            <div className="col-xs-4 no-padding">
              <div className="input-group dashboard-search">
                <span className="input-group-addon">
                  <span className="icon-search"></span>
                </span>
                <input type="text" ref="searchWord" onKeyUp={this.onSearchChange} className="inputText" required />
                <span className="floating-label">Search</span>
              </div>
            </div>

            <div className="col-xs-8 list-grid-holder pull-right no-padding patient-buttons">
              {roleID === 1 || roleID === 2 &&
                <ul className="pull-right d-flex align-items-center">
                  <li className='popup-icon' onClick={() => { this.setState({ showCsvModal: true }) }}>
                    <img src={require('./../../../images/info.png')} alt='info' title="click here to see sample patient csv" />
                  </li>
                  <li>
                    <div className="uploadWrapper">
                      <label htmlFor="uploadPatientsCSV">+ Upload CSV</label>
                      <input id="uploadPatientsCSV" type="file" ref="fileUrl" onChange={this.uploadPatientsCSV} />
                    </div>
                  </li>
                  <li>
                    <button className="gray-button" onClick={this.add_patient}>+ Add Patient</button>
                  </li>
                </ul>
              }
            </div>


          </div>

          <div className="white-box patient-details list-patient">
            <div className="button filter pull-right">
              <li onClick={this.showFilter}><span className="icon-filter"></span> FILTER BY</li>
              <ul className={this.state.showFilter ? "filter-dropdown show" : "filter-dropdown"}>
                <li className="hidden-overlay" onClick={this.closeFilter}></li>
                <li>
                  <span onClick={this.showPsychList}>Psychiatrist</span>
                  <ul onChange={this.selectPsyc} className={this.state.showPsychList ? "show" : ""}>

                    {drData.PsychiatristList}

                  </ul>
                </li>

                <li><span onClick={this.showTherpList}>Therapist</span>
                  <ul onChange={this.selectTherp} className={this.state.showTherpList ? "show" : ""}>
                    {drData.TheraoistListList}

                  </ul>
                </li>
                <li className="apply-filter text-center" >
                  <span onClick={this.applyFilter} >Apply</span>
                  <span onClick={this.unCheckList} >Clear</span>
                </li>

              </ul>
            </div>
            <Tabs onSelect={this.handleSelect} selectedIndex={this.state.CurrentTab} >

              <TabList className="nav nav-tabs">
                <Tab className="button header-padding">RED FLAGGED</Tab>
                <Tab className="button header-padding">ACTIVE</Tab>
                {roleID === 1 || roleID === 2 && <Tab className="button header-padding">DEACTIVATED</Tab>}
                {roleID === 1 || roleID === 2 && <Tab className="button header-padding">PENDING</Tab>}
                {roleID === 1 || roleID === 2 && <Tab className="button header-padding">EXPIRED</Tab>}
                {roleID === 1 || roleID === 2 && <Tab className="button header-padding">ALL</Tab>}
              </TabList>

              <TabPanel>
                <table className="table">
                  {redFlagPatienData && redFlagPatienData.length > 0 &&
                    <thead><tr><th>GUID</th><th><span className="patient-overflow">Name</span></th><th><span className="patient-overflow">Email</span></th><th>Phone</th><th>Psychiatrist</th><th>Therapist</th><th>Status</th></tr></thead>
                  }
                  <tbody>
                    {redFlagPatienData}
                  </tbody>
                </table>

              </TabPanel>

              <TabPanel>
                <table className="table">
                  {activePatienData && activePatienData.length > 0 &&
                    <thead><tr><th>GUID</th><th><span className="patient-overflow">Name</span></th><th><span className="patient-overflow">Email</span></th><th>Phone</th><th>Psychiatrist</th><th>Therapist</th><th>Status</th></tr></thead>
                  }
                  <tbody>
                    {activePatienData}
                  </tbody>
                </table>
              </TabPanel>

              {roleID === 1 || roleID === 2 &&
                <TabPanel>
                  <table className="table">
                    {deactivePatienData && deactivePatienData.length > 0 &&
                      <thead><tr><th>GUID</th><th><span className="patient-overflow">Name</span></th><th><span className="patient-overflow">Email</span></th><th><span className="patient-overflow">Date</span></th><th>Phone</th><th>Psychiatrist</th><th>Therapist</th><th>Status</th></tr></thead>
                    }
                    <tbody>
                      {deactivePatienData}
                    </tbody>
                  </table>
                </TabPanel>
              }
              {roleID === 1 || roleID === 2 &&

                <TabPanel>
                  <table className="table">
                    {pendingPatienData && pendingPatienData.length > 0 &&
                      <thead><tr><th>GUID</th><th><span className="patient-overflow">Name</span></th><th><span className="patient-overflow">Email</span></th><th>Phone</th><th>Psychiatrist</th><th>Therapist</th><th>Status</th><th>Action</th></tr></thead>
                    }
                    <tbody>
                      {pendingPatienData}
                    </tbody>
                  </table>
                </TabPanel>
              }
              {roleID === 1 || roleID === 2 &&

                <TabPanel>
                  <table className="table">
                    {expiredPatienData && expiredPatienData.length > 0 &&
                      <thead><tr><th>GUID</th><th><span className="patient-overflow">Name</span></th><th><span className="patient-overflow">Email</span></th><th>Date</th><th>Phone</th><th>Psychiatrist</th><th>Therapist</th><th>Status</th><th>Action</th></tr></thead>
                    }
                    <tbody>
                      {expiredPatienData}
                    </tbody>
                  </table>
                </TabPanel>
              }

              {roleID === 1 || roleID === 2 &&
                <TabPanel>
                  <table className="table">
                    {allPatienData && allPatienData.length > 0 &&
                      <thead><tr><th>GUID</th><th><span className="patient-overflow">Name</span></th><th><span className="patient-overflow">Email</span></th><th>Phone</th><th>Psychiatrist</th><th>Therapist</th><th>Status</th></tr></thead>
                    }
                    <tbody>
                      {allPatienData}
                    </tbody>
                  </table>
                </TabPanel>
              }
            </Tabs>
          </div>

          {this.state.okModalMessage && <ModalDialogCommon message={this.state.okModalMessage} action={this.closebox} />}
          {(roleID === 1 || roleID === 2 && !this.state.loader && this.state.totalRecords >= this.state.PageSize) &&
            <Pagination
              activePage={this.state.pageNO}
              itemsCountPerPage={this.state.PageSize}
              totalItemsCount={this.state.totalRecords}
              pageRangeDisplayed={5}
              onChange={this.onPageChange} />
          }
        </div>
        {this.state.showCsvModal && <div className='csv-popup'>
          <div className='popup-overlay' onClick={() => { this.setState({ showCsvModal: false }) }}></div>
          <div className='csv-info'>
            <div style={{ margin: '35px' }}>
              <div className="csvText">Please download the sample template</div>
              <div className="col-xs-12 no-padding recovery-buttons" style={{ textAlign: 'center' }}>
                <button className="gray-button" onClick={this.onDownload}>Download</button>
                <button className="white-button" onClick={() => { this.setState({ showCsvModal: false }) }}>Cancel</button></div>
            </div>

            {/* <img src={require('./../../../images/patient.png')} /> */}
          </div>
        </div>}
        {this.state.isShowDeleteModal && <ModalDialogCommon message={"Are you sure you want to delete?"} action={this.deletePatientById} cancel={"true"} action2={() => { this.setState({ isShowDeleteModal: false }) }} />}
        {this.state.copiedToClipboard && <ModalDialogCommon message={"Copied to clipboard"} action={this.copied} />}
      </div>

    );
  }
});


let mapStateToProps = (state) => {
  return {
    PatientsDetails: state.Patients,
    UserDetails: state.User,
    FacilitiesDetails: state.Facilites,
    DoctorList: state.User.DoctorList,
    userDeleted: state.User.userDeleted

  };
};

let mapDispatchToProps = (dispatch) => ({
  PatientsActions: bindActionCreators(PatientsActions, dispatch),
  FacilitiesActions: bindActionCreators(FacilitiesActions, dispatch),
  Dispatch: dispatch
});
export default connect(mapStateToProps,
  mapDispatchToProps)(withRouter(PatientsList));



/** WEBPACK FOOTER **
 ** ./src/components/admin/patients/patients-list.js
 **/